<template>
  <div class="user-login">
    <el-form ref="form" :model="form" :rules="rules" label-width="0" class="login-form">
      <h3 class="login-title">活动系统登录</h3>
      <el-form-item prop="user" class="login-item">
        <el-input v-model="form.user" placeholder="请输入账户名：" class="form-input" :autofocus="true"></el-input>
      </el-form-item>
      <el-form-item prop="pass" class="login-item">
        <el-input type="password" v-model="form.pass" placeholder="请输入账户密码：" class="form-input"></el-input>
      </el-form-item>
      <el-form-item class="login-item">
        <el-button size="large" icon="check" class="form-submit" @click="submit_register">注册</el-button>
        <el-button size="large" icon="check" class="form-submit" @click="submit_form">登录 </el-button>
      </el-form-item>
    </el-form>

  </div>
</template>
<script>
  export default {
    data() {
      return {

        form: {
          user: null,
          pass: null,
        },
        rules: {
          user: [{
            required: true,
            message: '请输入账户名！',
            trigger: 'blur'
          }],
          pass: [{
            required: true,
            message: '请输入账户密码！',
            trigger: 'blur'
          }]
        }

      }
    },
    methods: {
      submit_form() {
        const {
          user,
          pass
        } = this.form
        this.$http.user_login({
          user,
          pass
        }).then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push('/manage')
            window.localStorage.setItem('guruacuser', user)
            window.localStorage.setItem('guruacpass', pass)
          } else {
            this.$message({
              message: `(；へ：)!, ${res.data.message}`,
              type: 'warning',
              center: true
            })
          }
        })
      },
      submit_register() {
        this.$router.push("/register")
      }
    },
    mounted() {
      this.form.user = window.localStorage.getItem('guruacuser') || null;
      this.form.pass = window.localStorage.getItem('guruacpass') || null;
    },
    watch: {

    }
  }

</script>

<style scoped>
  .user-login {
    position: absolute;
    left: 0;
    top: 0;
    left: 0;
    right: 0;
    background: white;
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
  }

  .user-login h1 {
    text-align: center;
    padding: 20px;
  }

  .login-form {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }

  .login-title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/backend/login.vue